import React from 'react';
import { DomainNs } from "ReactApp/Types/DomainNs";
import { motion } from 'framer-motion';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";


const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type Collection = {
    collectionName: string,
    textiles: DomainNs.VirtualModifierInterface[],
}
type SplitByCollectionTextilesSet = {
    [key: string]: Collection
}
type TextileSwitcherV1Props = {
    productCard: ShowableProductCard
}

const TextileSwitcherV1 = observer((props: TextileSwitcherV1Props) => {

    let splitByCollectionTextilesSet: SplitByCollectionTextilesSet = {};

    props.productCard.textileSwitchers.forEach(v => {
        if (!(String(v.switcherData.collectonId) in splitByCollectionTextilesSet)) {
            splitByCollectionTextilesSet[v.switcherData.collectonId]
                = {
                collectionName: v.switcherData.collectionName,
                textiles: [],
            }
        }
        splitByCollectionTextilesSet[v.switcherData.collectonId]
            .textiles.push(v);
    });

    const switchTextile = (
        event: React.MouseEvent<HTMLDivElement>,
        textile: DomainNs.VirtualModifierInterface
    ) => {
        const textileOption = event.currentTarget;
        props.productCard.switchVirtualModifier(
            textile.switcherData.virtualModifierId,
            textile.isActive
        );
    }

    function renderImage(data: DomainNs.TextileSwitcherData)
    {
        return (
            <img 
                className="image-v1"
                loading="lazy" 
                src={data.imgSrc} 
                alt={data.imgAlt}
                />
        );
    }

    function renderTextiles(textiles: DomainNs.VirtualModifierInterface[]) {
        return textiles.map((textile, k) => {

            let wrapClasses: string[] = [];
            wrapClasses = [
                'textile-switcher-v1__option-block'
            ];
            if (textile.isAvailable === false) {
                wrapClasses.push('textile-switcher-v1__option-block_disabled _hide');
            }
            if (textile.isActive === true) {
                wrapClasses.push('textile-switcher-v1__option-block_active');
            }

            return (
                <div
                    className={wrapClasses.join(' ')}
                    key={`ob${k}`}
                    onClick={textile.isAvailable ? (e) => {
                        switchTextile(e, textile)
                    }: undefined}
                    >
                    <div className="textile-switcher-v1__option-image">
                        {textile.switcherData.imgSrc !== '' 
                            && renderImage(textile.switcherData)}
                    </div>
                    <motion.div
                        className='textile-switcher-v1__option-name'
                        variants={sentence}
                        initial="hidden"
                        animate="visible"
                    >
                        {splitLine(textile.switcherData.textileLabel)}
                    </motion.div>
                </div>
            );
        });
    }

    return (
        <div className="textile-switcher-v1">
            {Object.keys(splitByCollectionTextilesSet).map(key => {
                let collection: Collection = splitByCollectionTextilesSet[key];
                return (
                    <div className="textile-switcher-v1__collection-block" key={`cb${key}`}>
                        <motion.div
                            className='textile-switcher-v1__collection-head'
                            variants={sentence}
                            initial="hidden"
                            animate="visible"
                        >
                            {splitLine(collection.collectionName)}
                        </motion.div>
                        <div className="textile-switcher-v1__option-wrap">
                            {renderTextiles(collection.textiles)}
                        </div>
                    </div>
                ); 
            })}
        </div>
    );

})

export default TextileSwitcherV1;